import { post } from '../utils/http'
import type { IReqSendSms, IReqLogin, IResLogin, IReqRegister } from '@/types/apis/user'

// 发送验证码
export const apiSendSmsVerifyCode = (data: IReqSendSms) => post('/api/AIUser/SendSmsVerifyCode', data)

// 手机号验证码登录
export const apiLoginWithPhone = (data: IReqLogin) => post<IResLogin>('/api/AIUser/LoginWithPhone', data)

// 手机号注册
export const apiRegisterWithPhone = (data: IReqRegister) => post<boolean>('/api/AIUser/RegisterWithPhone', data)
